<div class="right-container" [class.coverage-layout]="tabControl === 1">
  <!-- <div class="row"> -->
  <div id="resultsSection" class="col-12">
    <ng-container *ngIf="tabControl !== 1 && !showMyNewsFeed && headerMenuActive !== 'MyCoverage'" [ngTemplateOutlet]="searchToolbar"></ng-container>
    <ng-template #searchToolbar>
    <div class="search-toolbar-row" [class.search-toolbar-row--coverage]="tabControl === 1">
      <div class="search-toolbar-main">
        <app-search (setKeywordsEmitter)="getKeywords($event)">
        </app-search>
        <div class="search-toolbar-profile" *ngIf="tabControl === 1">
          <app-author-contact-profile></app-author-contact-profile>
          <app-outlet-contact-profile></app-outlet-contact-profile>
          <app-topic-contact-profile></app-topic-contact-profile>
        </div>
      </div>
    </div>
    </ng-template>

    <toast-notification></toast-notification>
    <div *ngIf="tabControl === 0; then topicsContent"></div>
    <div *ngIf="tabControl === 1" class="coverage-viewport">
      <ng-container [ngTemplateOutlet]="coverageContent"></ng-container>
    </div>
    <div *ngIf="tabControl === 3; then collectionContent"></div>

    <ng-template #collectionContent>
      <!--      <app-toolbar-content></app-toolbar-content>-->
      <p-splitter
        [panelSizes]="collectionPanelSizes"
        [gutterSize]="2"
        [style]="{ height: '100%' }"
      >
        <ng-template pTemplate>
          <div class="p-mr-2">
            <topics-ranked-list
              [topicsList]="topicsSavedList"
            ></topics-ranked-list>
          </div>
        </ng-template>
        <ng-template pTemplate>
          <div class="p-ml-2">
            <app-collection-content></app-collection-content>
          </div>
        </ng-template>
      </p-splitter>
    </ng-template>

    <ng-template #topicsContent>
      <div class="home-text" *ngIf="headerMenuActive === 'Home'">
        <h3>Search for a topic to get started...</h3>
      </div>
      <div *ngIf="headerMenuActive === 'Topics'">
        <div *ngIf="showMyNewsFeed">
          <app-news-feed></app-news-feed>
        </div>
        <div *ngIf="showTopicsContent">
          <!--          <app-toolbar-content></app-toolbar-content>-->
          <topics-ranked-list
            [topicsList]="topicsSavedList"
          ></topics-ranked-list>
        </div>
      </div>
      <div *ngIf="headerMenuActive === 'MyCoverage'">
        <app-my-coverage-reporting></app-my-coverage-reporting>
      </div>
    </ng-template>

    <ng-template #coverageContent>
      <div class="search-results-layout" *ngIf="headerMenuActive === 'Home' || headerMenuActive === 'Topics'">
        <div class="search-results-left">
          <ng-container *ngIf="!showMyNewsFeed" [ngTemplateOutlet]="searchToolbar"></ng-container>
          <section class="search-results-people" aria-label="Authors and outlets">
            <app-facets-table displayMode="people"></app-facets-table>
          </section>
        </div>
        <section class="search-results-coverage" aria-label="Coverage">
          <app-coverage></app-coverage>
        </section>
        <aside class="search-results-related" aria-label="Related companies and topics">
          <app-facets-table displayMode="tags"></app-facets-table>
        </aside>
      </div>
    </ng-template>
  </div>
  <!-- </div> -->
</div>
<p-confirmDialog
  key="unfollowConfirmation"
  [style]="{ width: '40vw' }"
  [baseZIndex]="10000"
  rejectButtonStyleClass="p-button-text"
></p-confirmDialog>

<app-off-canvas></app-off-canvas>
<app-payment-successful></app-payment-successful>
<app-sign-up></app-sign-up>
<app-author-manager></app-author-manager>
<app-outlet-manager></app-outlet-manager>
<app-company-manager></app-company-manager>
<app-topic-manager></app-topic-manager>
<app-select-project></app-select-project>
<app-alert-settings></app-alert-settings>
<app-categories-list></app-categories-list>
<app-category-manager></app-category-manager>
<app-report-missing-incorrect-data></app-report-missing-incorrect-data>
<app-welcome></app-welcome>
<app-my-account></app-my-account>
